<app-breadcrumbs></app-breadcrumbs>
<section class="buy-wifi-product wrapper text-white buywifi-bgcolor wifi-key-page">
    <div class="row-wrapper">
        <div class="header-div">
            <h2 class="header">{{'wifiKeys.heading' | translate}}</h2>
        </div>
        <div class="wifi-notification wifi-info text-info">
            <div class="text-white" *ngIf="!showEBforPointsBuy">{{'wifiKeys.info' | translate}}</div>
            <div class="text-white" *ngIf="showEBforPointsBuy">You can use your WiFi access on 1 device at the time during the flight. To enjoy WiFi on more than 1 device, just buy access for more devices. You log in with the same booking details on all devices.</div>
        </div>
        <div class="buy-wifi-product-container" id="buy-wifi-product-container">
            <section class="wrapper outbound-wifi-select">
                <div class="outbound-trip-details">

                    <div class="wifi-ond-details">

                        <div class="wifi-origin-wrapper" *ngIf="!showEBforPointsBuy">
                            <div class="wifi-origin-name"> {{currentSegment.departureAirport.name}}</div>
                            <div class="wifi-origin-code mrgn-l-5">
                                <span> {{currentSegment.departureAirport.code}}</span>
                            </div>
                        </div>
                        <div class="wifi-origin-wrapper" *ngIf="showEBforPointsBuy">
                            <div class="wifi-origin-name"> {{origin.name}}</div>
                            <div class="wifi-origin-code mrgn-l-5">
                                <span> {{origin.iataCode}}</span>
                            </div>
                        </div>
                        <div class="wifi-destination-wrapper" *ngIf="!showEBforPointsBuy">
                            <span class="mrgn-l-5"> - </span>
                            <div class="wifi-destination-name"> {{currentSegment.arrivalAirport.name}}</div>
                            <div class="wifi-destination-code mrgn-l-5">
                                <span> {{currentSegment.arrivalAirport.code}}</span>
                            </div>
                        </div>
                        <div class="wifi-destination-wrapper" *ngIf="showEBforPointsBuy">
                            <span class="mrgn-l-5"> - </span>
                            <div class="wifi-destination-name"> {{destination.name}}</div>
                            <div class="wifi-destination-code mrgn-l-5">
                                <span> {{destination.iataCode}}</span>
                            </div>
                        </div>

                        <div class="wifi-info-wrapper pull-right" *ngIf="!ischarter">
                            <button class="wifi-access-info-icon" type="button" id="infoIconButton" tabindex="-1">
                                <svg class="info-wifi-icon" role="presentation" tabindex="-1">
                                    <use xlink:href="#cl--info" href="#cl--info" tabindex="-1"></use>
                                </svg>
                            </button>
                            <a href="javascript:void(0)" id="readMoreId" tabindex="0" (click)="readmoreContent()">Read
                                more</a>
                        </div>

                    </div>

                    <div class="col large-12 medium-12 small-12 mrg-btm-8">
                        <div class="passenger-wifi-wrap">
                            <div class="traveler-wifi-info">
                                <div class="traveler-name"
                                    [ngClass]="{'traveler-name-border col large-6 medium-6 small-12  pull-left':currencyList.length > 0}">
                                    <div class="col large-6 medium-6 small-6">
                                        <div class="sas-wifi-keys small-12 medium-12 traveler-txt-clr">
                                            {{'devicesToConnect' | translate}}
                                        </div>
                                        <div class="price-val medium-12 small-12" *ngIf="!showEBforPointsBuy">
                                            {{price | formatPrice:true:true:'no'}}{{'inclVAT' | translate}}
                                        </div>
                                        <div class="price-val medium-12 small-12" *ngIf="showEBforPointsBuy">
                                            {{price}}{{'pointsPerDevice' | translate}}
                                        </div>
                                    </div>
                                    <div class="col large-6 medium-6 small-6 wifi-keys-add">
                                        <div class="wifi-count input-set" tabindex="0" id="buywifiKeysBlock" role="menu"
                                            [attr.aria-label]="(passengerInfo.firstName)+' '+(passengerInfo.lastName)+' '+ (price)+' per key (incl.
                      VAT.),'+' '+('wifiKeys.announcement' | translate)">
                                            <a href="javascript:void(0);" role="button" class="icon-decrease pull-left "
                                                [ngClass]="{'disabled':sessionValue == 0}" tabindex="-1" aria-label=""
                                                (click)="decreaseSession();" id="decrease-key">

                                            </a>
                                            <div class="selected-count" role="alert" id="selected-sessionvalue">
                                                {{sessionValue}}
                                                <span class="sr-only"> selected</span>
                                            </div>

                                            <a href="javascript:void(0);" role="button"
                                                class="icon-increase pull-right "
                                                [ngClass]="{'disabled':sessionValue == 99}" tabindex="-1"
                                                (click)="increaseSession();" id="increase-key">

                                            </a>
                                            <div class="tool-tip bottom-right small error" role="alert"
                                                *ngIf="showKeyErrorMessage">
                                                <div class="tool-tip-inner">
                                                    <span>{{'message.7011056' | translate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="buy-wifi-price-info large-6 medium-6 small-12 pull-right pad-l-0"
                                    *ngIf="currencyList.length > 0">
                                    <div class="col small-12 medium-9 large-09 ">
                                        <div class="line-shadow"></div>
                                    </div>

                                    <div class="col large-2 medium-3 small-12 currency-sel pull-right">
                                        <div class="currency-code">
                                            <div class="input-set dropdown-native white">
                                                <label class="sr-only" for="currency-code"
                                                    [attr.aria-label]="selectedCurrency + ' selected. currency code'">Currency
                                                    Code</label>
                                                <span class="caret icon-down"></span>
                                                <span class="selected-value">{{selectedCurrency}}</span>
                                                <select name="currency-list" id="currency-code" aria-expanded="true"
                                                    tabindex="0"
                                                    (change)="onChangeCurrency($event.target.value, $event)">
                                                    <option selected style="display:none;"></option>
                                                    <option [value]="i"
                                                        *ngFor="let  list of currencyList;let i = index">{{list.rel}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="email-wifi-info" *ngIf="!showEBforPointsBuy && !ischarter">
                                <div class="email-address-field" *ngIf="isEmailPresent">Your email address:
                                    {{buyWifiService.receiptEmailAddress}}</div>
                                <div class="email-address-field" *ngIf="!isEmailPresent && !ischarter">Add email address where you
                                    want the report to be sent</div>
                                <div class="email_link-wrapper" *ngIf="!ischarter"><a href="javascript:void(0)"
                                        id="emailEditId" tabindex="0"
                                        (click)="loadUpdateEmailOverLay($event)">{{emailLinkText}}</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="clear"></div>
        </div>
    </div>
</section>
<section class="buy-wifi-email text-white" *ngIf="readmoreOverLay">
    <div class="modal fade in readmore-content" id="myModal" role="dialog" style="display: block">
        <div class="wrapper">
            <div class="modal-body">
                <div class="header-div">
                    <button type="button" class="modal-close" id="update-modal-close" (click)="closeOverlay()"
                        tabindex="0" [attr.aria-label]="('close' | translate)" (keyup.enter)="closeOverlay()">×
                    </button>

                </div>
                <div>
                <app-wifiaccess-prices></app-wifiaccess-prices>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="clear"></div>
<app-footer *ngIf="sessionValue === 0"></app-footer>
<app-cart [sessionValue]='sessionValue' (cartButtonEvent)="cartButtonEvent()" [price]='price' [selectedCurrency]='selectedCurrency' *ngIf="sessionValue > 0 && (isEmailPresent || ischarter)"></app-cart>
<div class="clear"></div>
<!-- Buy Wifi Email Update Overlay -->
<section class="modal wifi-onboard-email-overlay" id="wifi-onboard-email-overlay" *ngIf="updateEmailOverLay"
    style="display: block">
    <app-error></app-error>
    <div class="modal-dialog medium">
        <div class="modal-tnc-content">
            <div class="modal-header">
                <div class="modal-close" (keydown)="keyshiftTabFocus($event, '#tnc-connect');"
                    (keydown.enter)="closeEmailOverlay()" (click)="closeEmailOverlay()" tabindex="0"
                    id="update-modal-close" [attr.aria-label]="('close' | translate)">
                    <svg class="close-icon" role="presentation">
                        <use xlink:href="#in--close" href="#in--close"></use>
                    </svg>
                </div>
                <h4 [innerHtml]="((isUnconfirmedTicket) ? ('emailOverlay.staffHeading' | translate): ('emailOverlay.commercialHeading'  | translate))"
                    class="modal-title" id="tnc-header"></h4>
                <p
                    [innerHtml]="((isUnconfirmedTicket) ? 
                ('emailOverlay.staffInstruction'  | translate): ((isEmailPresent) ? 
                ('emailOverlay.commercialInstruction_email'  | translate): ('emailOverlay.commercialInstruction' | translate)))">
                </p>
            </div>
            <form class="" role="form" name="buy-wifi-updateEmail" [formGroup]="emailForm"
                (ngSubmit)="emailFormSubmit()" novalidate="" form-autofill-fix="" autocomplete="off">
                <div class="req-info-email-only login large-6 medium-6 small-12">
                    <p>{{'reqInfo' | translate}}</p>
                </div>
                <div class="input-set large-6 medium-6 small-12 col activate-input email-input">
                    <label id="emailLabel" [ngClass]="{'top-set': emailTopSet}" for="email">{{'email' |
                        translate}}*</label>
                    <input formControlName='email' tabindex="0"
                        (keydown.tab)="(!emailForm.valid)?'#update-modal-close':'#update-email-connect'"
                        id="update-email-input" name="" type="text" [(ngModel)]="buyWifiService.receiptEmailAddress"
                        (focus)="onActiveEmail()" aria-label="Email" (blur)="onBlurEmail()"
                        (keydown.Tab)="tabFromEmailInput($event)" required aria-required="true" aria-invalid="false" />
                    <div class="tool-tip bottom-left small error onboard-tool-tip"
                        *ngIf="email.invalid && showEmailErrorMsg" role="alert">
                        <div class="tool-tip-inner">
                            <div *ngIf="email.errors.required">{{'message.7011059' | translate}}</div>
                            <div *ngIf="email.errors.pattern">{{'message.7011060' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
                <div class="modal-tnc-body">
                    <div class="tnc-content-wrapper">
                        <div class="wrap-button tnc-connect-container">
                            <button class="btn primary large small-12 email-update" id="email.update" tabindex="0"
                                (keydown.Tab)="keytabFocus($event, '#update-modal-close');">{{'tnc.continue' |
                                translate}}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="buy-wifi-email text-white" *ngIf="showAlternativePaymentConfirmationScreen">
    <app-error></app-error>
    <div class="modal-product" id="myModalProduct" style="display: block">
        <div class="modal-dialog-product medium">
            <div class="modal-content-product">
                <div class="modal-header-product">
                    <button type="button" class="modal-close-product" data-modal-close="wifi-onboard-switch"
                        (keydown.enter)="closeAlternatePaySelectionOverlay()"
                        (click)="closeAlternatePaySelectionOverlay()" tabindex="0" id="close-switch"
                        [attr.aria-label]="('close' | translate)">×</button>
                    <h4 class="modal-title-product" id="switch-header">{{'alternatePaySelection.header' | translate}}</h4>
                </div>
                <div class="modal-body-product">
                    <div class="switch-content-wrapper">                        
                        <p>There is not enough points in the account to complete the transaction of purchasing Wifi access for <strong>{{noOfKeys}}</strong> device(s). Please select payment with credit card or try again with a fewer number of Wifi sessions</p>
                        <div class="wrap-button paySelect-card-container">
                            <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more"
                                (click)="redirectToBuywifi()">{{'paySelection.paywithCard' |
                                translate}}</button>
                        </div>
                        <div class="wrap-button paySelect-points-container">
                            <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more"
                                (click)="closeAlternatePaySelectionOverlay()">{{'alternatePaySelection.paywithPoints' |
                                translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="clear"></div>
<span class="sr-only" id="sr-cart-updateemail" tabindex="-1"></span>